import React, { useCallback, useEffect, useRef } from "react";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import { ROUTES } from "../utils/Routes";
import TestComponent from "../components/TestComponent";
import { getController, registerController } from "../utils/Utils";
import Button from "../ui/Button";

export default function TestController(props) {
    const {
        route = ROUTES.MISC.TEST
    } = props;

    const testRef = useRef(null);

    const runTestComponent = useCallback((msg = "", callback = () => { }) => {
        testRef.current?.sayHello(msg, callback);
    }, []);


    const runTestController = useCallback((msg = "", callback = () => { }) => {
        const ret = msg + " run on controller";
        alert(ret)
        callback(ret + " returned...");
    }, []);

    useEffect(() => {
        return registerController("test", {
            runTestComponent,
            runTestController
        });
    }, []);



    return (
        <div className="controller controller-layout">
            <div className="header-card">
                <TestComponent ref={testRef} />
            </div>

            <div className="list-card flex-height">

            </div>

            <div className="list-card flex-height">
                <Button onClick={() => {
                    getController("test")?.runTestComponent?.("param", (e) => {
                        console.log(e);
                    })
                    

                }}>Child component</Button>
                <Button onClick={() => {
                 
                    getController("test")?.runTestController?.("param", (e) => {
                        console.log(e);
                    })

                }}>Controller</Button>
            </div>

            <div className="flex-bottom">
                <div className="shim" />
                <Divider />
                <div className="nav-wrapper">
                    <Space style={{ padding: "0px 15px" }}>
                        <Nav nav={[]} />
                    </Space>
                </div>
            </div>
        </div>
    );
}